import _objectWithoutProperties from "/home/circleci/project/web-front/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/objectWithoutProperties";
import _slicedToArray from "/home/circleci/project/web-front/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/slicedToArray";
import _objectSpread from "/home/circleci/project/web-front/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/objectSpread";
import $84925f526f90eebd$exports from "./ar-AE.module.js";
import $c0650163dc1b6f9d$exports from "./bg-BG.module.js";
import $b2b55661291de587$exports from "./cs-CZ.module.js";
import $deb83970956f6d5b$exports from "./da-DK.module.js";
import $aea1cb4c7ec97e1c$exports from "./de-DE.module.js";
import $3618d917e503a8d3$exports from "./el-GR.module.js";
import $9eb56bbbe8e31294$exports from "./en-US.module.js";
import $361c604b0fc269a3$exports from "./es-ES.module.js";
import $2f00170f4ee3ca01$exports from "./et-EE.module.js";
import $80ee16b64fab9fb5$exports from "./fi-FI.module.js";
import $be9d354476c08087$exports from "./fr-FR.module.js";
import $ffeb903ba092eb35$exports from "./he-IL.module.js";
import $1df6722c6f19728b$exports from "./hr-HR.module.js";
import $093d57e325bc9071$exports from "./hu-HU.module.js";
import $609dbdfbcad85bdb$exports from "./it-IT.module.js";
import $c08e84f882644048$exports from "./ja-JP.module.js";
import $5cd130489822fa21$exports from "./ko-KR.module.js";
import $ab5183739b6c5e7e$exports from "./lt-LT.module.js";
import $dd84a0b574be3f23$exports from "./lv-LV.module.js";
import $85eee97d14eef7b5$exports from "./nb-NO.module.js";
import $18781839f93b0314$exports from "./nl-NL.module.js";
import $1c40ffbbfe9f3bda$exports from "./pl-PL.module.js";
import $156880e329b1c717$exports from "./pt-BR.module.js";
import $b6d50b1d20768ce4$exports from "./pt-PT.module.js";
import $d8c38c691b006187$exports from "./ro-RO.module.js";
import $ed9b4bf7ce1fb1d7$exports from "./ru-RU.module.js";
import $51d8721afda4d678$exports from "./sk-SK.module.js";
import $fd37a27baae493e8$exports from "./sl-SI.module.js";
import $5505a1ca71ffd6f4$exports from "./sr-SP.module.js";
import $33670e148c84ad02$exports from "./sv-SE.module.js";
import $0bf46fdcdd7cb5f6$exports from "./tr-TR.module.js";
import $9d9765222bc08ca2$exports from "./uk-UA.module.js";
import $d737296cedcdee9f$exports from "./zh-CN.module.js";
import $09cd168ab18773f4$exports from "./zh-TW.module.js";
import { useId as $aIvin$useId, useDescription as $aIvin$useDescription, filterDOMProps as $aIvin$filterDOMProps, getSyntheticLinkProps as $aIvin$getSyntheticLinkProps, mergeProps as $aIvin$mergeProps } from "@react-aria/utils";
import { useGridListItem as $aIvin$useGridListItem, useGridList as $aIvin$useGridList } from "@react-aria/gridlist";
import { useInteractionModality as $aIvin$useInteractionModality, useFocusWithin as $aIvin$useFocusWithin } from "@react-aria/interactions";
import { useLocalizedStringFormatter as $aIvin$useLocalizedStringFormatter, useLocale as $aIvin$useLocale } from "@react-aria/i18n";
import { ListKeyboardDelegate as $aIvin$ListKeyboardDelegate } from "@react-aria/selection";
import { useState as $aIvin$useState, useRef as $aIvin$useRef, useEffect as $aIvin$useEffect } from "react";
import { useField as $aIvin$useField } from "@react-aria/label";
function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ /*
    * Copyright 2020 Adobe. All rights reserved.
    * This file is licensed to you under the Apache License, Version 2.0 (the "License");
    * you may not use this file except in compliance with the License. You may obtain a copy
    * of the License at http://www.apache.org/licenses/LICENSE-2.0
    *
    * Unless required by applicable law or agreed to in writing, software distributed under
    * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
    * OF ANY KIND, either express or implied. See the License for the specific language
    * governing permissions and limitations under the License.
    */
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */

var $d7323bca8d074eeb$export$653eddfc964b0f8a = new WeakMap();
function $d7323bca8d074eeb$export$4f8b5cda58b7e8ff(props, state, ref) {
  var _ref = (0, $aIvin$useLocale)(),
    direction = _ref.direction;
  var keyboardDelegate = props.keyboardDelegate || new (0, $aIvin$ListKeyboardDelegate)({
    collection: state.collection,
    ref: ref,
    orientation: "horizontal",
    direction: direction,
    disabledKeys: state.disabledKeys
  });
  var _ref2 = (0, $aIvin$useField)(_objectSpread({}, props, {
      labelElementType: "span"
    })),
    labelProps = _ref2.labelProps,
    fieldProps = _ref2.fieldProps,
    descriptionProps = _ref2.descriptionProps,
    errorMessageProps = _ref2.errorMessageProps;
  var _ref3 = (0, $aIvin$useGridList)(_objectSpread({}, props, fieldProps, {
      keyboardDelegate: keyboardDelegate,
      shouldFocusWrap: true,
      linkBehavior: "override"
    }), state, ref),
    gridProps = _ref3.gridProps;
  var _ref4 = (0, $aIvin$useState)(false),
    _ref5 = _slicedToArray(_ref4, 2),
    isFocusWithin = _ref5[0],
    setFocusWithin = _ref5[1];
  var _ref6 = (0, $aIvin$useFocusWithin)({
      onFocusWithinChange: setFocusWithin
    }),
    focusWithinProps = _ref6.focusWithinProps;
  var domProps = (0, $aIvin$filterDOMProps)(props);
  // If the last tag is removed, focus the container.
  var prevCount = (0, $aIvin$useRef)(state.collection.size);
  (0, $aIvin$useEffect)(function () {
    if (ref.current && prevCount.current > 0 && state.collection.size === 0 && isFocusWithin) ref.current.focus();
    prevCount.current = state.collection.size;
  }, [state.collection.size, isFocusWithin, ref]);
  $d7323bca8d074eeb$export$653eddfc964b0f8a.set(state, {
    onRemove: props.onRemove
  });
  return {
    gridProps: (0, $aIvin$mergeProps)(gridProps, domProps, _objectSpread({
      role: state.collection.size ? "grid" : null,
      "aria-atomic": false,
      "aria-relevant": "additions",
      "aria-live": isFocusWithin ? "polite" : "off"
    }, focusWithinProps, fieldProps)),
    labelProps: labelProps,
    descriptionProps: descriptionProps,
    errorMessageProps: errorMessageProps
  };
}
var $3bb15cc24d006ec5$exports = {};
$3bb15cc24d006ec5$exports = {
  "ar-AE": $84925f526f90eebd$exports,
  "bg-BG": $c0650163dc1b6f9d$exports,
  "cs-CZ": $b2b55661291de587$exports,
  "da-DK": $deb83970956f6d5b$exports,
  "de-DE": $aea1cb4c7ec97e1c$exports,
  "el-GR": $3618d917e503a8d3$exports,
  "en-US": $9eb56bbbe8e31294$exports,
  "es-ES": $361c604b0fc269a3$exports,
  "et-EE": $2f00170f4ee3ca01$exports,
  "fi-FI": $80ee16b64fab9fb5$exports,
  "fr-FR": $be9d354476c08087$exports,
  "he-IL": $ffeb903ba092eb35$exports,
  "hr-HR": $1df6722c6f19728b$exports,
  "hu-HU": $093d57e325bc9071$exports,
  "it-IT": $609dbdfbcad85bdb$exports,
  "ja-JP": $c08e84f882644048$exports,
  "ko-KR": $5cd130489822fa21$exports,
  "lt-LT": $ab5183739b6c5e7e$exports,
  "lv-LV": $dd84a0b574be3f23$exports,
  "nb-NO": $85eee97d14eef7b5$exports,
  "nl-NL": $18781839f93b0314$exports,
  "pl-PL": $1c40ffbbfe9f3bda$exports,
  "pt-BR": $156880e329b1c717$exports,
  "pt-PT": $b6d50b1d20768ce4$exports,
  "ro-RO": $d8c38c691b006187$exports,
  "ru-RU": $ed9b4bf7ce1fb1d7$exports,
  "sk-SK": $51d8721afda4d678$exports,
  "sl-SI": $fd37a27baae493e8$exports,
  "sr-SP": $5505a1ca71ffd6f4$exports,
  "sv-SE": $33670e148c84ad02$exports,
  "tr-TR": $0bf46fdcdd7cb5f6$exports,
  "uk-UA": $9d9765222bc08ca2$exports,
  "zh-CN": $d737296cedcdee9f$exports,
  "zh-TW": $09cd168ab18773f4$exports
};
function $fc6126c82a4601f1$export$3f568fff7dff2f03(props, state, ref) {
  var item = props.item;
  var stringFormatter = (0, $aIvin$useLocalizedStringFormatter)((0, /*@__PURE__*/$parcel$interopDefault($3bb15cc24d006ec5$exports)), "@react-aria/tag");
  var buttonId = (0, $aIvin$useId)();
  var _ref7 = (0, $d7323bca8d074eeb$export$653eddfc964b0f8a).get(state) || {},
    onRemove = _ref7.onRemove;
  var _ref8 = (0, $aIvin$useGridListItem)({
      node: item
    }, state, ref),
    rowProps = _ref8.rowProps,
    gridCellProps = _ref8.gridCellProps,
    states = _objectWithoutProperties(_ref8, ["rowProps", "gridCellProps"]); // We want the group to handle keyboard navigation between tags.
  delete rowProps.onKeyDownCapture;
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  var _ = states.descriptionProps,
    stateWithoutDescription = _objectWithoutProperties(states, ["descriptionProps"]);
  var onKeyDown = function onKeyDown(e) {
    if (e.key === "Delete" || e.key === "Backspace") {
      e.preventDefault();
      if (state.selectionManager.isSelected(item.key)) onRemove === null || onRemove === void 0 ? void 0 : onRemove(new Set(state.selectionManager.selectedKeys));else onRemove === null || onRemove === void 0 ? void 0 : onRemove(new Set([item.key]));
    }
  };
  var modality = (0, $aIvin$useInteractionModality)();
  if (modality === "virtual" && typeof window !== "undefined" && "ontouchstart" in window) modality = "pointer";
  var description = onRemove && (modality === "keyboard" || modality === "virtual") ? stringFormatter.format("removeDescription") : "";
  var descProps = (0, $aIvin$useDescription)(description);
  var isFocused = item.key === state.selectionManager.focusedKey;
  // @ts-ignore - data attributes are ok but TS doesn't know about them.
  var domProps = (0, $aIvin$filterDOMProps)(item.props);
  var linkProps = (0, $aIvin$getSyntheticLinkProps)(item.props);
  return _objectSpread({
    removeButtonProps: {
      "aria-label": stringFormatter.format("removeButtonLabel"),
      "aria-labelledby": "".concat(buttonId, " ").concat(rowProps.id),
      id: buttonId,
      onPress: function onPress() {
        return onRemove ? onRemove(new Set([item.key])) : null;
      },
      excludeFromTabOrder: true
    },
    rowProps: (0, $aIvin$mergeProps)(rowProps, domProps, linkProps, {
      tabIndex: isFocused || state.selectionManager.focusedKey == null ? 0 : -1,
      onKeyDown: onRemove ? onKeyDown : undefined,
      "aria-describedby": descProps["aria-describedby"]
    }),
    gridCellProps: (0, $aIvin$mergeProps)(gridCellProps, {
      "aria-errormessage": props["aria-errormessage"],
      "aria-label": props["aria-label"]
    })
  }, stateWithoutDescription, {
    allowsRemoving: !!onRemove
  });
}
export { $fc6126c82a4601f1$export$3f568fff7dff2f03 as useTag, $d7323bca8d074eeb$export$4f8b5cda58b7e8ff as useTagGroup };